module.exports = __webpack_public_path__ + "assets/img/icon01.79a516f0.png";